// extracted by mini-css-extract-plugin
export default {"notFoundMSGContainer":"styles_notFoundMSGContainer__QL97k","title":"styles_title__b2GEF","light":"styles_light__oE4KA","description":"styles_description__KERbv"};